<template>
  <div class="button">
    <button @click="onClick" class="button__change">
      <span class="button__content">
        {{ label }}
        <ion-icon name="swap-horizontal-outline"></ion-icon>
      </span>
    </button>
    <slot/>
  </div>
</template>

<script>
export default {
  name: "btnChange",
  props: {
    label: {
      required: true,
    },
  },
  methods: {
    onClick() {
      this.$emit('emit-click')
    }
  },
}
</script>

<style lang="scss" scoped>

.button {
  position: relative;

  &__change {
    background: #2F23D6;
    padding: 4px 12px;
    border: none;
    border-radius: 4px !important;
    transition: .2s;

    &:hover {
      background: #1D12B9;
    }
  }

  &__change > &__content {
    display: flex;
    align-items: center;
    flex-direction: row;
    color: #FFFFFF;
    font-size: 13px;
    font-weight: 400;
    line-height: 140.62%;

    ion-icon {
      margin-left: 13px;
      font-size: 18px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/vue/pages/components/buttons/btnChange.vue